import SubmissionDetails from './SubmissionDetails';
import SubmissionDetailsContainer from './SubmissionDetails.container';
export default SubmissionDetailsContainer(SubmissionDetails);
